(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nbd-swatch"] && !Shopify.designMode) return;
  try {
    NBD.onLoad(() => {
    if (customElements.get('nbd-swatch')) return;

    class NBDSwatch extends HTMLElement {
      constructor() {
        super();
        this.max = 512;
        this.ttl = 5 * 60 * 1000;
        this.handle = this.dataset.handle;
        // Availability differs by market, so cache per country.
        this.key = `${window.Shopify?.country || ''}:${this.handle}`;
      }

      connectedCallback() {
        this.render();
      }

      productUrl(handle) {
        const base = window.Shopify?.routes?.root || '/';
        return `${base}products/${handle}`;
      }

      update(ok) {
        this.toggleAttribute('data-show', ok);
        this.toggleAttribute('data-hide', !ok);
      }

      async render() {
        this.store = NBD.cache('Swatch', this.max);

        if (this.store.has(this.key)) {
          this.update(this.store.get(this.key));
          return;
        }

        try {
          const res = await fetch(this.productUrl(this.handle), { method: 'HEAD' });
          // Only a definite answer is cached; other errors may be transient.
          if (res.ok || res.status === 404) {
            this.store.put(this.key, res.ok, this.ttl);
          }
          this.update(res.ok);
        } catch {
          this.update(false);
        }
      }
    }

    customElements.define('nbd-swatch', NBDSwatch);
  });
  } catch(e) { console.error(e); }
})();

})();
